export enum RoleEnum {
  ROLE_USER = 'ROLE_USER',
  ROLE_POWER_USER = 'ROLE_POWER_USER'
}
